//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import { useEffect } from 'react';
import { useAuthHelper } from '../../AuthHelper';

// Function used to re-render the component 2 minutes before session timeout
// to ensure that the OpenSearch Dashboards session is always active
export function useDashboardRerenderInterval(
  setDashboardLoaded: (v: boolean) => void,
) {
  const { INACTIVITY_TIMEOUT } = useAuthHelper();
  const INACTIVITY_BUFFER = 2 * 60 * 1000; // Used to re-render 2 minutes before expiration
  const reRenderInterval = INACTIVITY_TIMEOUT - INACTIVITY_BUFFER;

  useEffect(() => {
    const interval = setInterval(() => {
      setDashboardLoaded(false); // Trigger re-render
    }, reRenderInterval);
    return () => clearInterval(interval);
  }, []);
}
